import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from "react-redux";
import {
    bbFormattedDateString,
    bbStringOfHyperlinkedVulnsFromArray,
    bbShortenString,
    getFirstCustomerId,
    mapObject,
    bbAppendRowPlaceholdersToTableDataArray,
    bbConstructionCone,
    bbScopeIcon,
    bbRiskDirectionArrow,
    bbGetModulePropertyFromIdOrName, BBModuleIcon
} from "../../../../util/bbHelpers";
import {
    fetchCustomers,
    fetchEventsAction,
    setCustomerInView,
} from "../../../../actions";
import ArrayDataTable from "../../tables/ArrayDataTable";
import { makeStyles } from '@material-ui/core/styles';
import PropTypes from "prop-types";
import Tooltip from "@material-ui/core/Tooltip";
import IntlMessages from "../../../../util/IntlMessages";
import {Badge} from "reactstrap";
import TableBody from "@material-ui/core/TableBody";
import TableRow from "@material-ui/core/TableRow";
import { TableCell} from "@material-ui/core";
import Table from "@material-ui/core/Table";
import BBIconVector from "../../../../assets/bbCustomIcons/BBIconVector";
import BBIconApprovedCheck from "../../../../assets/bbCustomIcons/BBIconApprovedCheck";
import ExitToAppSharpIcon from "@material-ui/icons/ExitToAppSharp";
import BBIconAdd from "../../../../assets/bbCustomIcons/BBIconAdd";
import BBIconSubtract from "../../../../assets/bbCustomIcons/BBIconSubtract";
import BBIconLink from "../../../../assets/bbCustomIcons/BBIconLink";
import BBIconUnlink from "../../../../assets/bbCustomIcons/BBIconUnlink";
import BBIconHumanTarget from "../../../../assets/bbCustomIcons/BBIconHumanTarget";
import BBIconNetworkNodes from "../../../../assets/bbCustomIcons/BBIconNetworkNodes";
import Link from "@material-ui/core/Link";

const useStyles = makeStyles((theme) => ({
    button: {
        margin: theme.spacing(1),
    },
}));

const TableContainer = (props) => {

    const {customerId} = props;

  // const [activeTab, setActiveTab] = useState('1');

  const classes = useStyles();
  // const handleChangeTab = (event, newTab) => {
  //   setActiveTab(newTab);
  // }

  /**************************/
  /*Setup State and Dispatch*/
  /**************************/
  const {customers, loadingCustomers, customerInView, loadingEvents, loadingEventsError, metaEvents} = useSelector(({customer}) => customer);
  const dispatch = useDispatch();
  //select the customer from the store if it exists, based on the props customerId
  const customer = customers ? customerId ? customers[customerId] : customerInView ? customers[customerInView] : null : null;
  //from the customer, pull the event data if it exists
  const events = customer ? customer.events ? customer.events : null : null;
  const totalNumEvents = (metaEvents && metaEvents[customer.CustomerId] && metaEvents[customer.CustomerId].events) ? metaEvents[customer.CustomerId].events : null;
  const eventsBatchSize = (metaEvents && metaEvents[customer.CustomerId] && metaEvents[customer.CustomerId].page_size) ? metaEvents[customer.CustomerId].page_size : 10;
  // const totalNumEvents = 25;

  useEffect(() => {
    // console.group("Events Table for customerId: ", customerId, " customer: ", customer, " events: ", events)
    // console.log("EventsTable here is the customers in the store", customers)
    //   console.log("EventsTable here is the metaEvents store", metaEvents);
    if (!customers && !loadingCustomers) {
      // console.log("Customers is empty, fetching.")
      dispatch(fetchCustomers());
    } else if (customer && events == null && !loadingEvents) {
          // console.log("events is empty, fetching events for customerId = ", customer.CustomerId);
          dispatch(fetchEventsAction({
              customerId: customer.CustomerId,
          }));
      } else if (customers && customerInView === null) {
        const defaultId = getFirstCustomerId(customers);
        // console.log("setting view to default customer, first in list: ", defaultId);
        dispatch(setCustomerInView(defaultId));
    }
    // console.groupEnd()
  }, [customers, customerId, customerInView, customer, events, dispatch, loadingEvents, loadingCustomers]);

  /**************************/
  /*End Setup State and Dispatch*/
  /**************************/

    const title = <span>{bbConstructionCone()} All Events</span>;

  const userTableHeadings = [
      "Date & Time",
      "Category",
      "Details",
      "Target",
      // "Created By"
  ];

  const translateEventDetailsToTableWidget = (eventId, eventTypeId, detailsJSON) => {
      try {
          const details = JSON.parse(detailsJSON);

          switch(eventTypeId) {
              case 1: //Execution Event
                  // {}
                  return (
                      <Tooltip title={`Remote Execution`}>
                          <span>
                              {bbRiskDirectionArrow(4)} <ExitToAppSharpIcon className={"text-danger"}/> Malicious software execution attempt.
                          </span>
                      </Tooltip>
                  )
              case 2: //Command & Control Event
                  // {}
                  return (
                      <Tooltip title={`Command and control attempt`}>
                          <span>
                              {bbRiskDirectionArrow(4)} <ExitToAppSharpIcon className={"text-danger"}/> Command and control activity during an attack.  Successful communication with downloaded malware allows attackers to control malicious software from a distance.
                          </span>
                      </Tooltip>
                  )
              case 3: //Privilege Escalation Event
                  // {}
                  return (
                      <Tooltip title={`Privilege Escalation!`}>
                          <span>
                              {bbRiskDirectionArrow(4)} <ExitToAppSharpIcon className={"text-danger"}/> Privilege escalation attempt was successful during a breach.
                          </span>
                      </Tooltip>
                  )
              case 4: //Discovery Event
                  // {}
                  return (
                      <Tooltip title={`Recon successful!`}>
                          <span>
                              {bbRiskDirectionArrow(3)} <ExitToAppSharpIcon className={"text-danger"}/> Discovery and reconnaissance action was successful during a breach.
                          </span>
                      </Tooltip>
                  )
              case 5: //Lateral Movement Event
                  // {}
                  return (
                      <Tooltip title={`Lateral Movement!`}>
                          <span>
                              {bbRiskDirectionArrow(4)} <ExitToAppSharpIcon className={"text-danger"}/> Lateral movement successful during a breach.
                          </span>
                      </Tooltip>
                  )
              case 6: //Persistence Event
                  // {}
                  return (
                      <Tooltip title={`Evaded!`}>
                          <span>
                              {bbRiskDirectionArrow(3)} <ExitToAppSharpIcon className={"text-danger"}/> Achieved persistence during a breach.
                          </span>
                      </Tooltip>
                  )
              case 7: //Defense Evasion Event
                  // {}
                  return (
                      <Tooltip title={`Evaded!`}>
                          <span>
                              {bbRiskDirectionArrow(3)} <ExitToAppSharpIcon className={"text-danger"}/> Evaded client defenses during a breach.
                          </span>
                      </Tooltip>
                  )
              case 8: //Credential Access Event
                  // {}
                  return (
                      <Tooltip title={`Credential Access achieved!`}>
                          <span>
                              {bbRiskDirectionArrow(4)} <ExitToAppSharpIcon className={"text-danger"}/> Credential access attempt successful during a breach.
                          </span>
                      </Tooltip>
                  )
              case 9: //Collection Event
                  // {}
                  return (
                      <Tooltip title={`Collection achieved!`}>
                          <span>
                              {bbRiskDirectionArrow(4)} <ExitToAppSharpIcon className={"text-danger"}/> Data collection attempt successful during a breach.
                          </span>
                      </Tooltip>
                  )
              case 10: //Exfiltration Event
                  // {}
                  return (
                      <Tooltip title={`Exfiltartion achieved!`}>
                          <span>
                              {bbRiskDirectionArrow(4)} <ExitToAppSharpIcon className={"text-danger"}/> Data exfiltration attempt successful during a breach.
                          </span>
                      </Tooltip>
                  )
              case 11: //Target Add event
                  // {
                  //     "ProviderId": "discovery",
                  //     "OutOfScope": "0",
                  //     "Fqdn": "api.weatheralpha.com"
                  // }
                  return (
                      <span>

                          <BBIconNetworkNodes/> <Tooltip title={`Sources: ${details["ProviderId"]}`}>
                              <span>
                              New System Target Found.<br/>
                                  FQDN: <code>{details["Fqdn"]}</code>
                                  &nbsp;Scope Determination: {bbScopeIcon(details["OutOfScope"])}
                              </span>
                          </Tooltip>
                      </span>

                  )

              case 12: //Target Activation Event
                  // null details
                  return (
                      <Tooltip title={`Target activated.`}>
                          <span>
                              <BBIconLink /> This System Target was activated because it appears to be active and associated with this client.
                          </span>
                      </Tooltip>
                  )
              case 13: //Target Deactivation Event
                  // null details
                  return (
                      <Tooltip title={`Target deactivated.`}>
                          <span>
                            <BBIconUnlink /> This System Target was deactivated because it appears to either not be active or no longer associated with this client.
                          </span>
                      </Tooltip>
                  )
              case 14: //TTarget Reconnaissance Event
                  //Test data as of 16 Feb 2021
              // {
              //     "Fqdn": "license.beta.service.hyperqube.io",
              //     "Registered Organization Name": "Amazon Technologies Inc.",
              //     "Registered Point of Contact": "None",
              //     "Registered Email Address": "amzn-noc-contact@amazon.com",
              //     "Registered City": "Ashburn",
              //     "Registered State": "Virginia",
              //     "Registered Country": "United States",
              //     "Target Os": "Undetermined",
              //     "Target Ports": "443",
              //     "Target Services": "https",
              //     "Target Vulnerabilities": "None",
              //     "Http Title": "None",
              //     "Type": "update"
              // }


                  const reconKeys = Object.keys(details);
                  const filteredReconKeys = reconKeys.filter(item => item !== "Fqdn");
                  return (
                      <>
                          Reconnaissance event for <code><Tooltip title={details["Fqdn"]}><span>{bbShortenString(details["Fqdn"], 35, true)}</span></Tooltip></code> complete.  Observations:
                          <Table className={classes.table} size="small" >
                              <TableBody>
                                  {filteredReconKeys.map(key => (
                                      <TableRow key={`${eventId}row${key}`}>
                                          <TableCell key={`title${eventId}row${key}`}>
                                              {key}
                                          </TableCell>
                                          <TableCell key={`data${eventId}row${key}`} style={{fontSize:"small"}}>
                                              <Tooltip title={details[key]}><span>{bbShortenString(details[key], 65, true)}</span></Tooltip>
                                          </TableCell>
                                      </TableRow>
                                  ))}

                              </TableBody>
                          </Table>
                      </>

                  )


                  // const service1DetailsParsed = JSON.parse(details["Service 1 Details"]);
                  // const service2DetailsParsed = JSON.parse(details["Service 2 Details"]);
                  // const service3DetailsParsed = JSON.parse(details["Service 3 Details"]);
                  // const service4DetailsParsed = JSON.parse(details["Service 4 Details"]);
                  // const service5DetailsParsed = JSON.parse(details["Service 5 Details"]);
                  // const service6DetailsParsed = JSON.parse(details["Service 6 Details"]);
                  //
                  // return (
                  //     <Tooltip title={`Raw details: ${detailsJSON}`}>
                  //     <span>
                  //     {`Target: ${details.Fqdn} | Registration Info: POC Name ${details.RegPoc} Address ${details.RegAddress}
                  //     Email ${details.RegEmail} | Services Observed ${details.Services}
                  //     Open Ports Observed ${<code>details.Ports</code>} Vulnerabilities Observed ${details.Vulnerabilities}.
                  //     Target Ownership Score: ${details["Target Ownership Score"]}.`}
                  //   </span>
                  //     </Tooltip>
                  //
                  // )

              case 16: //Target Attack Vector Addition Event
                  // {
                  //     "Name": "Fortinet SSL VPN Common Credentials Attack",
                  //     "Description": "Attempt to log into a targetted Fortinet SSL VPN through a public-facing web interface using default or popular credentials."
                  // }
                  return (
                      <Tooltip title={`${details["Description"]}`}>
                      <span>
                          {bbRiskDirectionArrow(3)} {details["Name"]}
                      </span>
                      </Tooltip>
                  )

              case 17: //Target Attack Vector Approval Event
                  // {}
                  return (
                      <Tooltip title={`${details["Description"]}`}>
                      <span>
                          <BBIconApprovedCheck/> {details["Name"]}
                      </span>
                      </Tooltip>
                  )
              case 18: //Target Attack Vector Attack Event
                  // {}
                  return (
                      <Tooltip title={`${details["Description"]}`}>
                      <span>
                          <BBIconVector/> {details["Name"]}
                      </span>
                      </Tooltip>
                  )
              case 19: //Target Attack Vector Conclusion Event
                  // {}
                  return (
                      <Tooltip title={`${details["Description"]}`}>
                      <span>
                          {bbRiskDirectionArrow(1)} {details["Name"]}
                      </span>
                      </Tooltip>
                  )
              case 20: //Target Out Of Scope Event
                  // {}
                  return (
                      <>
                          {bbScopeIcon(true)} <Tooltip title={`A Target was placed out of scope.  Out of scope targets will be monitored, but not attacked.`}>
                          <span>
                              {details["Changed by"]} designated a Target as Out of Scope (OOS).
                          </span>
                      </Tooltip>

                    </>
                  )
              case 21: //Target In Scope Event
                  // {}
                  return (
                      <>
                          {bbScopeIcon(false)} <Tooltip title={`A Target was placed in scope`}>
                          <span>
                              {details["Changed by"]} designated a Target as In-Scope.
                          </span>
                      </Tooltip>
                          </>
                  )
              case 22: //Identity Addition Event
                  // {
                  //     "CustomerId": "523241959",
                  //     "Email Address": "brooke@weatheralpha.com",
                  //     "Email Type": "personal",
                  //     "Email Source": "hunter.io",
                  //     "First Name": "Brooke",
                  //     "Last Name": "Cunningham",
                  //     "Position": "Operations Officer",
                  //     "Phone Number": "None",
                  //     "Sources": "{'domain': 'slideshare.net', 'uri': 'http://slideshare.net/billfrischling/weather-alpha-weather-imact-assessment-sample', 'extracted_on': '2015-01-29', 'last_seen_on': '2020-01-17', 'still_on_page': True}",
                  //     "Confidence": 94,
                  //     "LinkedIn": "None",
                  //     "Twitter": "None",
                  //     "Created DateTime": "2020-10-19 11:38:10.748861",
                  //     "Phishing Attempts": 0,
                  //     "Phishing Attempts Successful": 0,
                  //     "Phishing Attempts Detail": "None"
                  // }
                  // const parsedSources = JSON.parse(details.Sources);
                  // // console.log("parsed: ", parsedResults);
                  // //const scanResults = JSON.parse(parsedResults.scan);
                  //
                  // return (
                  //     <Tooltip title={`Sources: ${parsedSources}`}>
                  //         <span>
                  //         Added Human Target.<br/>
                  //             First Name: {details["First Name"]}
                  //             &nbsp;Last Name: {details["First Last"]}
                  //             &nbsp;Email: <code>{details["Email Address"]}</code>
                  //             &nbsp;Position: {details["Position"]}
                  //             {details["Phone Number"] !== "None" && (
                  //             <>&nbsp;Phone Number:  {details["Phone Number"]}</>
                  //                 )}
                  //             {details["LinkedIn"] !== "None" && (
                  //                 <>&nbsp;LinkedIn:  {details["LinkedIn"]}</>
                  //             )}
                  //             {details["Twitter"] !== "None" && (
                  //                 <>&nbsp;Twitter:  {details["Twitter"]}</>
                  //             )}
                  //             &nbsp;CIRT Confidence Level: {details["Confidence"]}
                  //
                  //         </span>
                  //     </Tooltip>
                  // )

                  const identityKeys = Object.keys(details);
                  // const filteredReconKeys = reconKeys.filter(item => item !== "Fqdn");
                  return (
                      <>
                          <BBIconHumanTarget/> New Human Target Found:
                          <Table className={classes.table} size="small" >
                              <TableBody>
                                  {identityKeys.map(key => (
                                      <TableRow key={`${eventId}row${key}`}>
                                          <TableCell key={`title${eventId}row${key}`}>
                                              {key}
                                          </TableCell>
                                          <TableCell key={`data${eventId}row${key}`} style={{fontSize:"small"}}>
                                              <Tooltip title={details[key]}><span>{bbShortenString(details[key], 65, true)}</span></Tooltip>
                                          </TableCell>
                                      </TableRow>
                                  ))}

                              </TableBody>
                          </Table>
                      </>

                  )
              case 23: //Identity Activation Event
                  // {}
                  return (

                      <Tooltip title={`A Human Target was designated active.`}>
                          <span>

                              <BBIconLink /> {details["Changed by"]} designated a Human Target as "active" because it appears to be valid and associated with the client.
                          </span>
                      </Tooltip>
                  )
              case 24: //Identity Deactivation Event
                  // {}
                  return (
                      <Tooltip title={`A Human Target was designated inactive.`}>
                          <span>

                              <BBIconUnlink /> {details["Changed by"]} designated a Human Target as "inactive" because it appears the target no longer exists or is no longer associated with the client.
                          </span>
                      </Tooltip>
                  )
              case 25: //Customer Service Start Event
                  // {}
                  return (
                      <Tooltip title={`A client or member of the BreachBits staff enabled Continuous Attacks.`}>
                          <span>
                            A client or member of the BreachBits staff <Badge color="bb-risk-lowest"><IntlMessages id={"badge.cirt.active"}/></Badge> Continuous Attacks.
                          </span>
                      </Tooltip>
                  )
              case 26: //Customer Service Stop Event
                  // {}
                  return (
                      <Tooltip title={`A client or member of the BreachBits staff disabled Continuous Attacks.`}>
                          <span>
                            A client or member of the BreachBits staff <Badge color="bb-risk-medium"><IntlMessages id={"badge.cirt.inactive"}/></Badge> Continuous Attacks.
                          </span>
                      </Tooltip>
                  )

              case 27: //Customer SLA Approved Event
                  // {"Cycle Complete DateTime": "2021-02-16 02:35:23"}
                  // const key = "Cycle Complete DateTime"
                  return (
                      <Tooltip title={`Event detailing the approval of BreachBits Service Level Agreement.`}>
                          <span>
                              A member of the client's company approved the BreachBits SLA.
                          </span>
                      </Tooltip>
                  )
              case 28: //Customer Reconnaissance and Discovery Cycle Event
                // {"Cycle Complete DateTime": "2021-02-16 02:35:23"}
                  const key = "Cycle Complete DateTime"
                  return (
                      <Tooltip title={`Event detailing a discovery cycle conducted to identify new targets, data or identities.`}>
                          <span>
                              {key} : {bbFormattedDateString(details[key], 'long')}
                          </span>
                      </Tooltip>
                  )
              case 29: //Customer User Addition Event
                  //"{\"CustomerAdded\": \"912413138\", \"User Added\": \"b@c.com\", \"IsManager\": true,
                  // \"Source Ip Address\": \"104.131.65.39\",
                  // \"User Agent\": \"Mozilla/5.0 (Macintosh; Intel Mac OS X 11_1_0) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/87.0.4280.88 Safari/537.36\"}"
                  return (
                      <Tooltip title={`User Agent: ${details["User Agent"]}`}>
                      <span>
                          <BBIconAdd /> {`User's Email address: `}<code>{details["User Added"]}</code> {`| Manager? ${details.IsManager ? 'Yes' : 'No'}. Added from IP: `}<code>{details["Source Ip Address"]}</code>
                      </span>
                      </Tooltip>
                  )

              case 30: //Customer User Removal Eventƒcy
                  // {
                  //     "Customer Removed": "912413138",
                  //     "User Removed": "michael.bluth1@bluth.co"
                  // }
                  return (
                      <Tooltip title={`This user's BreachBoard account was removed.`}>
                          <span>
                          <BBIconSubtract /> Removed a user from BreachBoard.<br/>
                              Username/Email: <code>{details["User Removed"]}</code>
                          </span>
                      </Tooltip>
                  )
              // case 31:
              //     return ""

              case 32: //New Customer Event
                  // {
                  //     "Source Ip Address": "127.0.0.1",
                  //     "User Agent": "PostmanRuntime/7.26.8"
                  // }
                  return (
                      <Tooltip title={`User Agent: ${details["User Agent"]}`}>
                      <span>
                          <BBIconAdd /> {`Added from IP: `}<code>{details["Source Ip Address"]}</code>
                      </span>
                      </Tooltip>
                  )
              case 33: //Customer Settings Update Event
                  // {
                  //     "Lateral Movement Authorized": "1",
                  //     "Persistence Authorized": "1",
                  //     "Credential Access Authorized": "1",
                  //     "Data Collection Authorized": "1",
                  //     "Recon Enabled": "1",
                  //     "Perimeter Attacks Enabled": "1",
                  //     "Phishing Attacks Enabled": "1",
                  //     "Scanning Enabled": "1",
                  //     "Changed at": "134.122.0.222"
                  // }
                  const keys = Object.keys(details);
                  const filteredKeys = keys.filter(item => item !== "Changed at");
                  return (
                      <>
                          The following settings were changed changed from <code>{details["Changed at"]}</code>:
                          <Table className={classes.table} size="small">
                              <TableBody>
                                  {filteredKeys.map(key => (
                                  <TableRow key={`${eventId}row${key}`}>
                                      <TableCell key={`title${eventId}row${key}`}>
                                          {key}
                                      </TableCell>
                                      <TableCell key={`data${eventId}row${key}`}>
                                          <input type={"checkbox"} checked = {details[key] === "1"} disabled={true} key={`databox${eventId}row${key}`}/>
                                      </TableCell>
                                  </TableRow>
                                  ))}

                              </TableBody>
                          </Table>
                      </>

                  )
              // case 34:
              //     return ""
              case 35: //Target Fqdn Addition
              // {"New fqdns": "stig101.hyperqube.io"}
                  const rawFqdns = details["New fqdns"];
                  const fqdnString = rawFqdns
                      ? Array.isArray(rawFqdns)
                          ? rawFqdns.length > 0
                              ? rawFqdns.join(", ")
                              : "None detected"
                          : rawFqdns
                      : "None detected"
                  return (
                      <span>

                          <BBIconLink /> <Tooltip title={`FQDNs are added when CIRT has confident indications based on one or more observations. The presence of FQDNs does not necessarily increase your risk.`}>
                              <span>
                                  {`Added new FQDNs:`} <code>{fqdnString}</code>
                              </span>
                          </Tooltip>
                      </span>

                  )

              case 36: //Target Fqdn Removal
                  // {
                  //     "Removed fqdns": "lenovsquare.zeroeyes.com, lenoxsquare.zeroeyes.com"
                  // }
                  return (
                      <span>
                          {/*{bbRiskDirectionArrow("unknown")}*/}
                          <BBIconUnlink /> <Tooltip title={`FQDNs are removed when CIRT has not detected the previously identified FQDN over one or more consecutive observations.`}>
                              <span>
                                  {`Removed a FQDNs:`} <code>{details["Removed fqdns"]}</code>
                              </span>
                          </Tooltip>
                      </span>

                  )
              case 37: //Target Scan Event
                  //"{\"Scan Name\": \"Nmap TCP Discovery Scan (Common Ports)\",
                  // \"Scan Description\": \"Thorough NMAP scan of the 100 most common tcp ports.\",
                  // \"Scan Origination\": \"100.16.85.60\",
                  // \"Results\": \"{\\\"scan\\\": {\\\"command\\\": \\\"nmap -oX - -sV --version-all -A -T3 --top-ports 100 167.99.51.53\\\", \\\"ports\\\": \\\"7,9,13,21-23,25-26,37,53,79-81,88,106,110-111,113,119,135,139,143-144,179,199,389,427,443-445,465,513-515,543-544,548,554,587,631,646,873,990,993,995,1025-1029,1110,1433,1720,1723,1755,1900,2000-2001,2049,2121,2717,3000,3128,3306,3389,3986,4899,5000,5009,5051,5060,5101,5190,5357,5432,5631,5666,5800,5900,6000-6001,6646,7070,8000,8008-8009,8080-8081,8443,8888,9100,9999-10000,32768,49152-49157\\\", \\\"completed\\\": null, \\\"duration\\\": \\\"3.42\\\"}, \\\"results\\\": {\\\"status\\\": null, \\\"hostname\\\": null, \\\"ports\\\": {}}}\"}"
                  // console.log("trying to parse scan event: ", details.Results);
                  const parsedResults = JSON.parse(details.Results);
                  // console.log("parsed: ", parsedResults);
                  //const scanResults = JSON.parse(parsedResults.scan);

                  return (
                      <Tooltip title={`All ports checked: ${parsedResults.scan.ports}`}>
                      <span>
                      {`Scan Type: ${details["Scan Name"]} | Origination IP: ${details["Scan Origination"]}. Duration: ${parsedResults.scan.duration}. Ports checked: ${bbShortenString(parsedResults.scan.ports, 25, true)}`}
                    </span>
                      </Tooltip>

                  )
              // case 38:
              //     return ""
              // case 39:
              //     return ""
              // case 40:
              //     return ""
              // case 41:
              //     return ""
              // case 42:
              //     return ""
              // case 43:
              //     return ""
              // case 44:
              //     return ""
              case 45: //New Vulnerability Added Event
                  // const vulnWithHyperlink = <Tooltip title={`External Link: Read about ${details.Vulnerability} at the NIST National Vulnerability Database.`}><a target="_blank" href={`https://nvd.nist.gov/vuln/detail/${details.Vulnerability}`}>{details.Vulnerability}</a></Tooltip>
                  return (
                    <span>
                          {bbRiskDirectionArrow("unknown")}
                      {/*<Tooltip title={`Vulnerabilities are usually added when initial indications suggest the vulnerability may exist. If confirmed, this may have a risk impact. Vulnerability scanning is not perfect, and some vulnerabilities may never be found.`}>*/}
                                  <span>
                                  Discovered Possible Vulnerability: {bbStringOfHyperlinkedVulnsFromArray([details["Vulnerability"]])}
                                  </span>
                              {/*</Tooltip>*/}
                  </span>
                  )

              case 46: //Vulnerability Details Updated
                  // {
                  //     "Is Verified": true,
                  //     "Verified DateTime": "2020-10-23 16:52:12.476388"
                  // }
                  //or if its about to be deactivated
                  // {
                  //     "Is Verified": false,
                  //     "Verified DateTime": "2020-10-23 16:55:46.431523",
                  //     "VulnerabilityId": "35a8ffc6-1957-4df7-8d5c-cf48182d969f",
                  //     "Vulnerability": "CVE-2014-0012"
                  // }
                  const isGoodNews = !details["Is Verified"];
                  const riskArrow = isGoodNews ? bbRiskDirectionArrow(0) : bbRiskDirectionArrow(4)
                  const detailsString = isGoodNews
                    ? <>Confirmed no detectable presence of vulnerability: {bbStringOfHyperlinkedVulnsFromArray([details["Vulnerability"]])}</>
                    // : <>Confirmed No Detectable Presence of Vulnerability: {bbStringOfHyperlinkedVulnsFromArray([details["Vulnerability"]])}</>
                      : <>Confirmed presence of a vulnerability.</>
                  return (
                      <span>
                          {riskArrow}
                          <Tooltip title={`Vulnerabilities are usually added when initial indications suggest the vulnerability may exist. If confirmed, this may have a risk impact. Vulnerability scanning is not perfect, and some vulnerabilities may never be found.`}>
                                  <span>
                                      {detailsString}
                                  </span>
                              </Tooltip>
                  </span>
                  )
              case 47: //Vulnerability Deactivation Event
                  // {
                  //     "VulnerabilityId": "35a8ffc6-1957-4df7-8d5c-cf48182d969f",
                  //     "Vulnerability": "CVE-2014-0012"
                  // }
                  return (
                      <span>
                          {bbRiskDirectionArrow(0)}
                              <Tooltip title={`BB Vulnerability ID: ${details["VulnerabilityId"]}.  Vulnerabilities are usually deactivated when CIRT ceases to detect it after several consecutive observations.`}>
                                  <span>
                                  A CVE was deactivated on this System Target.<br/>
                                      Vulnerability: {bbStringOfHyperlinkedVulnsFromArray([details["Vulnerability"]])}
                                  </span>
                              </Tooltip>
                          </span>
                  )
              case 48: //Vulnerability Activation Event
                  // {
                  //     "VulnerabilityId": "35a8ffc6-1957-4df7-8d5c-cf48182d969f",
                  //     "Vulnerability": "CVE-2014-0012"
                  // }
                  return (
                      <span>
                          {bbRiskDirectionArrow(4)}
                          <Tooltip title={`BB Vulnerability ID: ${details["VulnerabilityId"]}.  Vulnerabilities are usually deactivated when CIRT ceases to detect it after several consecutive observations.`}>
                                  <span>
                                  A CVE was detected on this System Target.<br/>
                                      Vulnerability: {bbStringOfHyperlinkedVulnsFromArray([details["Vulnerability"]])}
                                  </span>
                              </Tooltip>
                          </span>
                  )
              case 49: //New Service Discovery Event
                  //"{\"ServiceId\": \"5b3cd432-e91f-4ae0-a0e8-5aedaf78f047\", \"Port\": 443, \"Service\": \"https\"}"
                  return (
                      <span>
                          {bbRiskDirectionArrow(3)}
                              <span>
                                  Service Discovered: <code>{details.Service}</code> | Port: <code>{details.Port}</code>
                              </span>
                      </span>
                  )
              case 50: //Service In Scope Event
                  // {
                  //     "ServiceId": "981665d8-f649-4201-9725-c5070d1e9c40",
                  //     "Service": "http",
                  //     "Port": 80
                  // }
                  return (
                      <span>
                          {bbScopeIcon(false)} <Tooltip title={`Service ID: ${details.ServiceId}`}>
                            <span>
                                Service Placed In-Scope: <code>{details.Service}</code> | Port: <code>{details.Port}</code>
                            </span>
                          </Tooltip>
                      </span>

                  )
              case 51: //Service Out of Scope Event
                  // {
                  //     "ServiceId": "981665d8-f649-4201-9725-c5070d1e9c40",
                  //     "Service": "http",
                  //     "Port": 80
                  // }
                  return (
                      <span>
                          {bbScopeIcon(true)} <Tooltip title={`Service ID: ${details.ServiceId}`}>
                            <span>
                                Service Placed Out of Scope: <code>{details.Service}</code> | Port: <code>{details.Port}</code>
                            </span>
                          </Tooltip>
                      </span>

                  )
              case 52: //Service Deactivated Event
              // {"ServiceId": "6fffc311-db02-4e4d-a49c-c95d694d6332", "Service": "http", "Port": 80}
                  return (
                      <span>
                          {bbRiskDirectionArrow(1)}
                          <Tooltip title={`Service ID: ${details.ServiceId}`}>
                            <span>
                                Service Appears to no longer be active: <code>{details.Service}</code> | Port: <code>{details.Port}</code>
                            </span>
                          </Tooltip>
                      </span>

                  )
              case 53: //Service Detail Update Event
                  //"{\"Service Details\": \"{\\\"recon\\\": {\\\"os\\\": null,
                  // \\\"banner\\\": \\\"HTTP/1.1 302 Found\\\\r\\\\nDate: Tue, 27 Oct 2020 03:56:50 GMT\\\\r\\\\nServer: Apache\\\\r\\\\nUpgrade: h2,h2c\\\\r\\\\n
                  // Connection: Upgrade\\\\r\\\\nLocation: https://www.denso.com/tw/zh/\\\\r\\\\nCache-Control: max-age=300\\\\r\\\\n
                  // Expires: Tue, 27 Oct 2020 04:01:50 GMT\\\\r\\\\nX-Endurance-Cache-Level: 2\\\\r\\\\n
                  // Content-Length: 0\\\\r\\\\nContent-Type: text/html; charset=UTF-8\\\\r\\\\n\\\\r\\\\n\\\",
                  // \\\"http\\\": {\\\"server\\\": \\\"Apache\\\", \\\"title\\\": null},
                  // \\\"ssl\\\": {\\\"issuer\\\": {\\\"C\\\": \\\"US\\\", \\\"CN\\\": \\\"Let's Encrypt Authority X3\\\",
                  // \\\"O\\\": \\\"Let's Encrypt\\\"}, \\\"subject\\\": {\\\"CN\\\": \\\"autodiscover.denso.com.tw\\\"}}}}\",
                  // \"ServiceId\": \"24ef11bc-4a20-45ae-8d01-5239c95da34b\", \"Service\": \"https\", \"Port\": 443}"
                  console.log("trying to parse scan event: ", details["Service Details"]);
                  const parsedServiceDetails = JSON.parse(details["Service Details"]);
                  console.log("parsed: ", parsedServiceDetails);
                  //const scanResults = JSON.parse(parsedResults.scan);
                  const reconHttpString = parsedServiceDetails.recon.http ? `HTTP Service: ${parsedServiceDetails.recon.http.server}` : "";
                  const reconOsString = parsedServiceDetails.recon.os ? parsedServiceDetails.recon.os : "Inconclusive";

                  return (
                      <Tooltip title={`Server Banner: ${details["Service Details"]}`}>
                      <span>
                      New observations about {`Service: ${<code>details.Service</code>} | Running on Port: ${<code>details.Port</code>}. Operating System: ${reconOsString} ${reconHttpString}`}
                    </span>
                      </Tooltip>

                  )
              case 54: //Initial Access Event
                  // {}
                  return (
                      <Tooltip title={`Initial access gained!`}>
                          <span>
                              {bbRiskDirectionArrow(4)} <ExitToAppSharpIcon className={"text-danger"}/> Initial access was gained into a target network or host.
                          </span>
                      </Tooltip>
                  )

              case 56: //Service Module Addition Event
                  // {}
                  return (
                      <span>

                          <Tooltip title={`${bbGetModulePropertyFromIdOrName(details.ModuleId) ? bbGetModulePropertyFromIdOrName(details.ModuleId) : ""} Module Activated.`}>
                            <span>
                               {/*<BBIconHexModuleYes className={"text-electric-blue"}/>*/}
                                <BBModuleIcon module={details.ModuleId} iconSize={"x-large"}/>
                            </span>
                          </Tooltip>
                          <Link href={bbGetModulePropertyFromIdOrName(details.ModuleId, "breachboardUserGuideUrl")}>{bbGetModulePropertyFromIdOrName(details.ModuleId)} Module</Link> activated.
                      </span>
                  )
              case 57: //Service Module Removal Event
                  // {}
                  return (
                      <span>

                          <Tooltip title={`${bbGetModulePropertyFromIdOrName(details.ModuleId) ? bbGetModulePropertyFromIdOrName(details.ModuleId) : ""} Module Activated.`}>
                            <span>
                               {/*<BBIconHexModuleNo className={"text-grey"}/>*/}
                                <BBModuleIcon module={details.ModuleId} isActive = {false} iconSize={"x-large"}/>
                            </span>
                          </Tooltip>
                          <Link href={bbGetModulePropertyFromIdOrName(details.ModuleId, "breachboardUserGuideUrl")}>{bbGetModulePropertyFromIdOrName(details.ModuleId)} Module</Link> deactivated.
                      </span>
                  )

              default:
                  return <span>
                      {bbConstructionCone()}
                      <Tooltip title={`Coming Soon: This event Type ID: ${eventTypeId} is under construction. | Event ID: ${eventId}`}>
                          <span>
                              {(detailsJSON && detailsJSON !== "")? detailsJSON : "More information coming soon."}
                          </span>
                      </Tooltip>
                  </span>
          }

      } catch (e) {
          console.warn(`CHECK FOR MALFORMED JSON -- Error thrown in translateEventDetailsToTableWidget: ${e} | Event ID: ${eventId} | Event Type ID: ${eventTypeId}`, "| Raw value of .Event (JSON): ", detailsJSON);
          return <span>
              {bbConstructionCone()}
              <Tooltip title={`We're making upgrades to give you even better information about this event type.  Check back soon! | Event ID: ${eventId} | Event Type ID: ${eventTypeId}`}>
                      <span>
                          <em>
                            Improvements in progress, please check back soon.
                          </em>
                    </span>
            </Tooltip>
          </span>
      }
  }

    //peel the state data into a form the dataTable can read
  const tableData = events ? mapObject(events, (key, event) => {
      //v2.0b, if there is already a target in the store, display the FQDN. if not, just the targetId
      const target = event.TargetId ? customer.targets ? customer.targets[event.TargetId] ? customer.targets[event.TargetId] : null : null : null;
      const human = event.IdentityId ? customer.humans ? customer.humans[event.IdentityId] ? customer.humans[event.IdentityId] : null : null : null;
      const friendlyFirstName = human ? human["First Name"] ? human["First Name"] : "" : null;
      const friendlyLastName = human ? human["Last Name"] ? human["Last Name"] : "" : null;
      const friendlyPosition = human ? human["Position"] ? human["Position"] : "" : null;
      const friendlyEmail = human ? human["Email Address"] ? <code>{human["Email Address"]}</code> : "" : null;
      const friendlyHumanDisplay = `${friendlyFirstName} ${friendlyLastName} ${friendlyPosition}`
    return (
        {
            id: event.Id ? event.Id: `${key}_eventsTableRow`,
            ["Date & Time"]: <Tooltip title={`${bbFormattedDateString(event["Created DateTime"], 'long')} - Event ID: ${event.Id} By: ${event["Created By"]}`}><span>{bbFormattedDateString(event["Created DateTime"])}</span></Tooltip>,
            Category: <Tooltip title={event["Event Type"].Description}><span>{event["Event Type"].Name}</span></Tooltip>,
            Details: translateEventDetailsToTableWidget(event.Id, event["Event Type"].Id, event.Details),
            Target:
                target
                    ? target.Fqdn
                        ? Array.isArray(target.Fqdn)
                            ? target.Fqdn.length > 0
                                ? <Tooltip title={`${target.Fqdn.join(", ")} - Target ID: ${event.TargetId}`}><span>{bbShortenString(target.Fqdn.join(", "), 25, true)}</span></Tooltip>
                                : "None detected"
                            : <Tooltip title={`${target.Fqdn} - Target ID: ${event.TargetId}`}><span>{bbShortenString(target.Fqdn, 25, true)}</span></Tooltip>
                        : <Tooltip title={`Target ID: ${event.TargetId}`}><span>{bbShortenString(target.IpAddress, 15)}</span></Tooltip>
                    : event.TargetId
                        ? <Tooltip title={`Target ID: ${event.TargetId}`}><span>{bbShortenString(event.TargetId, 9)}</span></Tooltip>
                        : human
                            ? <Tooltip title={`Human Target: ${friendlyHumanDisplay}`}><span>{bbShortenString(friendlyHumanDisplay, 9)} {friendlyEmail}</span></Tooltip>
                            : "N/A"
            // ["Created By"] : event["Created By"]
        }
    )
  }) : null;


    const ghostRowFetchFunction = (pageNumber) => {
        console.log("ghostRowFetchFunction called with page number", pageNumber)
        dispatch(fetchEventsAction({
            customerId: customer.CustomerId,
            pageNumber: pageNumber
        }));

    }

    const tableDataAsArray = () => {
        // console.log("Creating targetsTableData as array from targetTableData ", tableData);
        let i=0, arr=[];
        for (let ob in tableData) {
            // console.log("ob is ", tableData[ob])
            arr[i++]=tableData[ob];
        }

        const arrayWithGhosts = bbAppendRowPlaceholdersToTableDataArray(arr, totalNumEvents, eventsBatchSize, ghostRowFetchFunction);
        // console.log("(Events) Added ghosts to the data array.  result: ", arrayWithGhosts)

        return arrayWithGhosts;
    }


  if ( (events || totalNumEvents === 0) && !loadingEventsError) {
    // console.log("EventsTable loading is finished here is the customers in the store", customers, "and table data", tableDataAsArray())
    return (
        <div className={""} >
            <ArrayDataTable tableData={tableDataAsArray()} columnHeaders={userTableHeadings} overrideRowsPerPage = {eventsBatchSize} title={title} maxRecordsDisplayOverride = {totalNumEvents}/>
        </div>
    );
  } else if (loadingEvents || loadingCustomers) {
    return (
        <div className={""} >
            <ArrayDataTable tableData={null} columnHeaders={userTableHeadings} overrideRowsPerPage = {eventsBatchSize} title={title} loading={true} numSkeletonRows={30}/>
        </div>
    );

  } else {
    return (
        <div className={""} >
            <ArrayDataTable tableData={null} columnHeaders={userTableHeadings} overrideRowsPerPage = {eventsBatchSize} title={title} loading={true} numSkeletonRows={30}/>
        </div>

    );
  }


}
TableContainer.propTypes = {
    customerId: PropTypes.string,
};

export default TableContainer